/**
 * IST (Indian Standard Time) formatting utilities.
 * All dates displayed in the app use Asia/Kolkata timezone.
 */

const IST_OPTIONS = { timeZone: 'Asia/Kolkata' };

export function formatDateIST(dateStr) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return '';
  return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric', ...IST_OPTIONS });
}

export function formatTimeIST(dateStr) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return '';
  return date.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', ...IST_OPTIONS });
}

export function formatDateTimeIST(dateStr) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return '';
  return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', ...IST_OPTIONS });
}

export function formatFullDateIST(dateStr) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return '';
  return date.toLocaleDateString('en-IN', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', ...IST_OPTIONS });
}

export function todayDateIST() {
  return new Date().toLocaleDateString('en-IN', { ...IST_OPTIONS });
}
